import React, { useEffect, useState } from 'react'
import { FaUserCheck } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import axios from 'axios';

const api_url = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";
// For 'Login As User': you must pass client credentials as props from parent (user.jsx should provide these!)
function Seemore({ client_id, client_email }) {
  // You'll likely want to fetch/get client info from backend based on client_id,
  // Here, for the demo, we retrieve the client credential from an API call just-in-time.

  const [userdata, setUserData] = useState(null);

  useEffect(() => {
    // Ensure api_url is defined
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api_url}/auth/allusersinfo`);
        if (response.data && Array.isArray(response.data)) {
          const foundUser = response.data.find((data) => data.email === client_email);
          setUserData(foundUser || null);
        } else {
          setUserData(null);
        }
      } catch (err) {
        setUserData(null);
        // Optionally log error or set an "error" state
      }
    };

    if (client_email) {
      fetchData();
    }
  }, [client_email]);

  const handleLoginAsUser = async () => {


    try {
      // 1. Call the impersonation endpoint (don't send passwords!)
      const loginResp = await axios.post(`${api_url}/auth/impersonate/${userdata.id}`, {}, {
         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
  
      if (loginResp.data?.token) {
        // Store current admin token if you want to switch back later
        localStorage.setItem('admin_token', localStorage.getItem('token'));
        localStorage.setItem('impersonated_user_email', userdata.email); // optional, for display
       localStorage.setItem('is_impersonating', 'true'); // ✅ the flag
        // Overwrite current token with User token
        localStorage.setItem('token', loginResp.data.token);
        
        // Redirect
        window.location.href = '/';
      }
    } catch (err) {
      alert("Login failed: " + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className='w-[100%] flex justify-center items-center gap-2 mt-4'>
      <button
        className='p-2 hover:bg-[#00816a]  text-[#00816a] rounded-md text-[12px] flex items-center gap-1 font-semibold hover:text-[#fff] border-[1px] border-[#00816a]'
        onClick={handleLoginAsUser}
        type="button"
      >
        <FaUserCheck />
        Login As User
      </button>
      <button className='p-2 hover:bg-[#3f7fca]  text-[#3f7fca] rounded-md text-[12px] flex items-center gap-1 font-semibold hover:text-[#fff] border-[1px] border-[#3f7fca]'>
        <FaEdit />
        Manage WhiteListNumber
      </button>
    </div>
  );
}

export default Seemore
